import { StateModel } from '../../shared/models/default-state.model';
import {
  GET_POSITION_APPLICANTS_REQUEST,
  GET_POSITION_APPLICANTS_SUCCESS,
  GET_POSITION_APPLICANTS_ERROR,
  CLEAR_POSITION_APPLICANTS,
} from '../actions/position-applicants.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: [],
};

export const positionApplicantsReducer = (state: StateModel = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case GET_POSITION_APPLICANTS_REQUEST:
      return {
        ...state,
        loaded: false,
        loading: true,
      };

    case GET_POSITION_APPLICANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
      };

    case GET_POSITION_APPLICANTS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    case CLEAR_POSITION_APPLICANTS:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default positionApplicantsReducer;
